<script setup>
import EmptyStateLayout from 'dashboard/components-next/EmptyStateLayout.vue';
import Button from 'dashboard/components-next/button/Button.vue';
import McpServerCard from 'dashboard/components-next/captain/assistant/McpServerCard.vue';
import FeatureSpotlight from 'dashboard/components-next/feature-spotlight/FeatureSpotlight.vue';

const emit = defineEmits(['click']);

const onClick = () => {
  emit('click');
};

// Sample MCP servers for empty state preview
const sampleMcpServers = [
  {
    id: 1,
    name: 'filesystem',
    title: 'Filesystem Tools',
    description:
      'Provides secure file system access for reading and writing files. Use when users need to access, create, or modify files and directories.',
    assistant: { name: 'Development Assistant' },
    transport_type: 'stdio',
    enabled: true,
    icon: '',
    created_at: Date.now() / 1000,
  },
  {
    id: 2,
    name: 'database',
    title: 'Database Query Tools',
    description:
      'Connect to databases and execute queries. Useful for data retrieval, analytics, and database management tasks.',
    assistant: { name: 'Data Assistant' },
    transport_type: 'sse',
    enabled: true,
    icon: '',
    created_at: Date.now() / 1000,
  },
];
</script>

<template>
  <FeatureSpotlight
    :title="$t('CAPTAIN.MCP_SERVERS.EMPTY_STATE.FEATURE_SPOTLIGHT.TITLE')"
    :note="$t('CAPTAIN.MCP_SERVERS.EMPTY_STATE.FEATURE_SPOTLIGHT.NOTE')"
    fallback-thumbnail="/assets/images/dashboard/captain/mcp-servers-popover-light.svg"
    fallback-thumbnail-dark="/assets/images/dashboard/captain/mcp-servers-popover-dark.svg"
    learn-more-url="https://modelcontextprotocol.io"
    class="mb-8"
  />
  <EmptyStateLayout
    :title="$t('CAPTAIN.MCP_SERVERS.EMPTY_STATE.TITLE')"
    :subtitle="$t('CAPTAIN.MCP_SERVERS.EMPTY_STATE.SUBTITLE')"
    :action-perms="['administrator']"
  >
    <template #empty-state-item>
      <div class="grid grid-cols-1 gap-4 p-px overflow-hidden">
        <McpServerCard
          v-for="(server, index) in sampleMcpServers"
          :id="server.id"
          :key="`mcp-server-${index}`"
          :name="server.name"
          :title="server.title"
          :description="server.description"
          :assistant="server.assistant"
          :transport-type="server.transport_type"
          :enabled="server.enabled"
          :icon="server.icon"
          :created-at="server.created_at"
        />
      </div>
    </template>
    <template #actions>
      <Button
        :label="$t('CAPTAIN.MCP_SERVERS.ADD_NEW')"
        icon="i-lucide-plus"
        @click="onClick"
      />
    </template>
  </EmptyStateLayout>
</template>
